// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1q-2";
export var blackBorderOnHover = "_1q-7";
export var cell = "_1q-6";
export var cellContainer = "_1q-3";
export var checked = "_1q-8";
export var disabled = "_1q-5";
export var featuredIconCellContainer = "_1q-9";
export var featuredIconTextContainer = "_1q-b";
export var featuredIconWrapper = "_1q-a";
export var noBorder = "_1q-c";
export var orangeSelectedRow = "_4i-3";
export var overflowableText = "_1q-0";
export var overflowableTextContainer = "_1q-1";
export var row = "_1r-0";
export var rowCheckboxCell = "_1q-4";
export var selectableTable = "_4i-2";